"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchApiClientFactory = void 0;
var XmentService_1 = require("icf-search-client-shared/lib/services/XmentService");
var SearchApiClient_1 = require("../SearchApiClient");
var SearchApiClientFactory = /** @class */ (function () {
    function SearchApiClientFactory(user, config, skinConfig, xmentService, clientConstructor) {
        if (clientConstructor === void 0) { clientConstructor = SearchApiClient_1.SearchApiClient; }
        var _this = this;
        this.createClient = function () {
            var _a = _this._config, api = _a.api, useCambuilderOverrides = _a.useCambuilderOverrides;
            var user = _this._user;
            var skinConfig = _this._skinConfig;
            var index = _this._selectSearchIndexAndVersion(skinConfig, user);
            return new _this._clientConstructor(skinConfig.global.domain, api.headers, _this._getDefaultSearchKeywordIdsOverride(useCambuilderOverrides, skinConfig), _this._getBrowseConfigVersionOverride(useCambuilderOverrides, skinConfig), _this._getSearchBoostedFilterOverride(useCambuilderOverrides, skinConfig), skinConfig.global.gold_only_mode === "enabled", user.isAuthenticated ? user.sakey : undefined, undefined, index, {
                useSearchSnapshot: _this._xmentService.isXmentVariationOn(XmentService_1.USE_SEARCH_SNAPSHOT),
                shouldTranslateSearches: _this._xmentService.isXmentVariationOn(XmentService_1.SEARCH_TRANSLATE_TOP_FRENCH_SEARCHES),
                useActualCountryForRegionalBoost: _this._xmentService.isXmentVariationOn(XmentService_1.SEARCH_LOCAL_BOOST_ACTUAL_COUNTRY_SPAIN_XMENT_NAME),
                searchFreeAccountSignUpTile: _this._xmentService.isXmentVariationOn(XmentService_1.SEARCH_FREE_ACCOUNT_SIGN_UP_TILE_XMENT_NAME),
                searchReplaceLegacyBaseScore: _this._xmentService.isXmentVariationOn(XmentService_1.SEARCH_REPLACE_LEGACY_BASE_SCORE),
                loggedInRec: _this._xmentService.getXmentVariation(XmentService_1.SEARCH_LOGGED_IN_REC_XMENT),
                loggedOutRec: _this._xmentService.getXmentVariation(XmentService_1.SEARCH_LOGGED_OUT_REC_XMENT),
                applyRegionalBoost: _this._xmentService.isXmentVariationOn(XmentService_1.SEARCH_V4_REGIONAL_BOOST_XMENT_NAME),
            });
        };
        this._user = user;
        this._clientConstructor = clientConstructor;
        this._skinConfig = skinConfig;
        this._xmentService = xmentService;
        this._config = config;
    }
    SearchApiClientFactory.prototype._selectSearchIndexAndVersion = function (skinConfig, user) {
        var skinConfigIndexOverride = this._getSkinConfigIndexOverrides(skinConfig, user);
        if (this.isUserValidAndLoggedIn(user)) {
            return skinConfigIndexOverride ? skinConfigIndexOverride : "loggedinrecommender";
        }
        return skinConfigIndexOverride ? skinConfigIndexOverride : "default";
    };
    SearchApiClientFactory.prototype.isUserValidAndLoggedIn = function (user) {
        return user && user.isAuthenticated && typeof user.id === "number" && user.id > 0;
    };
    SearchApiClientFactory.prototype._getSkinConfigIndexOverrides = function (skinConfig, user) {
        if (this.isUserValidAndLoggedIn(user)) {
            return skinConfig.global.search_logged_in_index;
        }
        return skinConfig.global.search_logged_out_index;
    };
    SearchApiClientFactory.prototype._getDefaultSearchKeywordIdsOverride = function (useCambuilderOverrides, skinConfig) {
        if (useCambuilderOverrides) {
            return skinConfig.global.default_search_kids;
        }
    };
    SearchApiClientFactory.prototype._getBrowseConfigVersionOverride = function (useCambuilderOverrides, skinConfig) {
        if (useCambuilderOverrides) {
            return skinConfig.global.browse_config_version;
        }
    };
    SearchApiClientFactory.prototype._getSearchBoostedFilterOverride = function (useCambuilderOverrides, skinConfig) {
        if (useCambuilderOverrides) {
            return skinConfig.global.search_boosted_filters;
        }
    };
    return SearchApiClientFactory;
}());
exports.SearchApiClientFactory = SearchApiClientFactory;
//# sourceMappingURL=SearchApiClientFactory.js.map